import type { CSSProperties } from 'react';

export const DEFAULT_TODO_CATEGORY_NAME = '일반';
export const TODO_NOTE_DELETE_HOLD_MS = 820;

export function rowBackgroundStyle(color: string | undefined): CSSProperties | undefined {
  if (!color || !/^#[0-9A-Fa-f]{6}$/.test(color)) return undefined;
  return { background: `color-mix(in srgb, ${color} 18%, var(--color-panel, #f5f5f5))` };
}

export function todoEditorBlockTint(color: string | undefined): { className: string; style?: CSSProperties } {
  if (!color || !/^#[0-9A-Fa-f]{6}$/.test(color) || color.toLowerCase() === '#ffffff') return { className: '' };
  return {
    className: ' has-category-tint',
    style: {
      background: `color-mix(in srgb, ${color} 30%, var(--color-surface))`,
      ['--todo-block-cat-color' as string]: color,
    },
  };
}

/** 루틴 배지: 카테고리 색 배경 + 대비되는 글자색 */
export function routineBadgeStyle(color: string | undefined): CSSProperties {
  const fallback = '#10504a';
  const bg =
    color && /^#[0-9A-Fa-f]{6}$/.test(color) && color.toLowerCase() !== '#ffffff' ? color : fallback;
  const r = parseInt(bg.slice(1, 3), 16);
  const g = parseInt(bg.slice(3, 5), 16);
  const b = parseInt(bg.slice(5, 7), 16);
  const lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  const ink = lum > 0.62 ? '#1a1a1a' : '#ffffff';
  return {
    background: bg,
    color: ink,
    borderColor: `color-mix(in srgb, ${bg} 72%, ${ink})`,
  };
}

const TODO_TEXTAREA_MIN_PX = 40;

export function joinTodoMemo(title: string, body: string): string {
  if (body === '\n') return `${title}\n`;
  if (body === '') return title;
  return `${title}\n${body}`;
}

export function splitTodoMemo(combined: string): { title: string; body: string } {
  const i = combined.indexOf('\n');
  if (i === -1) return { title: combined, body: '' };
  const tail = combined.slice(i + 1);
  if (tail === '' && combined.endsWith('\n')) {
    return { title: combined.slice(0, i), body: '\n' };
  }
  return { title: combined.slice(0, i), body: tail };
}

export function sizeTextareaToContent(el: HTMLTextAreaElement | null, minPx = TODO_TEXTAREA_MIN_PX) {
  if (!el) return;
  el.style.height = '0px';
  el.style.height = `${Math.max(minPx, el.scrollHeight)}px`;
}
